import VirtualMachineWizard from "client/js/usercp/cloud/new";
import {PageHeader, FaIcon} from 'client/js/util/layout_utils';
import CreateAccount from 'client/js/usercp/cloud/create_account';
import Callout from 'client/js/util/callout';
import VerifyAccount from 'client/js/usercp/cloud/verify_account';
import { useResource } from 'client/js/util/rest_utils';

const PaymentRequiredSplash = () => {
  return <Callout calloutClass="warning" title="Vorauszahlung nötig">
      <p>Du hast die Zahlung per Kreditkarte für die Cloud-VPS ausgewählt. Für Neukunden ist eine einmalige Vorauszahlung nötig, bevor Du ein Cloud-VPS erstellen kannst. Bitte lade Guthaben auf, um eine Cloud-VPS zu erstellen:</p>

      <form className="form-inline" action="/usercp/webhosting/add_funds" method="post">
        <div className="input-group mr-1">
          <input className="form-control" type="number" defaultValue="5" min="5" max="100" name="amount" />
          <div className="input-group-append"><span className="input-group-text">&euro;</span></div>
        </div>
        <button className="btn btn-primary" type="submit"><FaIcon name="euro" /> Guthaben aufladen</button>
      </form>
    </Callout>;
}

const VerifyPaymentMethod = () => {
  return <Callout calloutClass="warning" title="Zahlungsmethode unbestätigt">
      <p>Die eingegebene SEPA-Bankverbindung ist noch nicht bestätigt. Wir haben eine Überweisung mit einem Code im Verwendungszweck auf Dein Konto getätigt. Den Code aus der Überweisung musst Du wieder bei uns eingeben um die Bankverbindung zu bestätigen. Die Bestätigung der Zahlungsmethode muss abgeschlossen sein, bevor Du die Cloud-VPS nutzen kannst.</p>

      <a className="btn btn-primary" href="/usercp/bankcode"><FaIcon name="ellipsis-h" /> Bestätigungscode eingeben</a>
    </Callout>;
}

const Form = () => {
  const { data: all_data, component } = useResource(['virtual_machines_new'], '/usercp/virtual_machines/new', {
    keepPreviousData: true,
  });

  const { data: placement_groups, component: placement_groups_component } = useResource(['placement_groups'], '/usercp/placement_groups', {
    keepPreviousData: true,
  });

  if(component)
    return component;

  if(placement_groups_component)
    return placement_groups_component;

  const data = all_data?.options;

  return <VirtualMachineWizard models={data.models}
                                templates={data.templates}
                                ssh_keys={data.ssh_keys}
                                placement_groups={placement_groups.placement_groups || []} />;
}

const Container = () => {
  const { data: all_data, component } = useResource(['cloud_account'], '/usercp/cloud_account.json', {
    keepPreviousData: true,
  });

  const data = all_data?.cloud_account;

  if(component)
    return component;

  if (!data || !data.enabled)
    return <CreateAccount />;

  if (data && data.sms_verification_required)
    return <VerifyAccount />;

  if(data && data.sms_verification_required)
    return <VerifyAccount />;

  if (data && data.payment_required)
    return <PaymentRequiredSplash />;

  if(data && data.payment_method_verification_required)
    return <VerifyPaymentMethod />;

  return (
      <>
        <PageHeader text="Cloud-VPS erstellen" back_url="/virtual_machines" />

        <Form />
      </>
    )
}

export default Container;
